var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "col-md-5 p-l-5 p-r-5 p-t-10" }, [
      _c("div", { staticClass: "tabs-container" }, [
        _c("ul", { staticClass: "nav nav-tabs" }, [
          _c("li", { class: { active: _vm.currentTab === "targets" } }, [
            _c("a", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TARGETS",
                  expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TARGETS'"
                }
              ],
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  _vm.currentTab = "targets"
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("li", { class: { active: _vm.currentTab === "targetGroups" } }, [
            _c("a", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CAMPAIGN_STEP_ROUTING_SELECTED_TABS_GROUPS",
                  expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_TABS_GROUPS'"
                }
              ],
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  _vm.currentTab = "targetGroups"
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "li",
            {
              class: { active: _vm.currentTab === "pingTrees" },
              attrs: { "feature-flag": "pingtree" }
            },
            [
              _c("a", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TREES",
                    expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TREES'"
                  }
                ],
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    _vm.currentTab = "pingTrees"
                  }
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab === "targets",
                  expression: "currentTab === 'targets'"
                }
              ],
              staticClass: "tab-content",
              attrs: { id: "tab-1" }
            },
            [
              _c("AvailableTargets", {
                attrs: {
                  "is-rpc": "vm.isRPC",
                  "on-update":
                    "vm.onUpdate({ routeContainer: vm.routeContainer })"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab === "targetGroups",
                  expression: "currentTab === 'targetGroups'"
                }
              ],
              staticClass: "tab-content",
              attrs: { id: "tab-2" }
            },
            [_c("AvailableTargetGroups")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentTab === "pingTrees",
                  expression: "currentTab === 'pingTrees'"
                }
              ],
              staticClass: "tab-content",
              attrs: { id: "tab-3", "feature-flag": "pingtree" }
            },
            [_c("AvailablePingTrees")],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-7 p-5" }, [_c("RoutingPlanEdit")], 1),
    _vm._v(" "),
    _c("div", { staticClass: "clearfix" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }